module.exports = __webpack_public_path__ + "static/media/notification.5205325a.svg";